import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import { APP_METADATA } from '../../config/constants';
import PageLayout from '../../components/PageLayout/PageLayout';
import InfoCard from '../../components/InfoCard/InfoCard';
import { educationData } from '../../data/educationData';
// Styles are now centralized in src/styles/

const Education = () => {
  useSEO({
    title: 'Education',
    description: `Educational background and qualifications of ${APP_METADATA.author}`,
    keywords: `${APP_METADATA.keywords}, Education, Qualifications, Imperial College London`,
  });

  return (
    <PageLayout title="Education" showTabs>
      <div className="gallery gallery--image">
        {educationData.map((education) => (
          <InfoCard
            key={education.id}
            image={education.image}
            imageAlt={education.imageAlt}
            title={education.title}
            subtitle={education.subtitle}
            date={education.date}
            description={education.description}
            items={education.items}
            wide={education.wide}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default Education;

